import { LogOut } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { authClient } from "@/lib/api/auth"
import { useSession } from "@/store/session"

function initialsOf(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  return parts
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()
}

// app-shell.md S5's user menu popup, driven by the real signed-in account
// instead of a mock identity. `subject-users.md`'s role/пункт caption isn't
// available yet (no пункт-name lookup endpoint — see userTableData.ts's own
// documented gap), so the trigger shows just the account's name/e-mail.
export function UserMenu() {
  const navigate = useNavigate()
  const user = useSession((s) => s.user)
  const clearSession = useSession((s) => s.clear)

  if (!user) return null

  const displayName = user.name || user.email

  const handleSignOut = async () => {
    await authClient.signOut()
    clearSession()
    navigate("/login", { replace: true })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="h-10 gap-2 px-2" variant="ghost">
          <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-muted text-xs font-medium">
            {initialsOf(displayName)}
          </div>
          <div className="hidden text-left text-sm leading-tight sm:grid">
            <span className="font-medium">{displayName}</span>
            <span className="text-xs text-muted-foreground">{user.rnokpp}</span>
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="bottom">
        <DropdownMenuLabel>
          {displayName}
          <span className="mt-1 block text-xs font-normal text-muted-foreground">
            {user.rnokpp}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={handleSignOut} variant="destructive">
          <LogOut />
          Вийти з АРМ
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
